import React, { createRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import logo from 'Images/logo_v1.svg';
import AvatarUser from '../demand/components/AvatarUser/index';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import MoreHoriz from '@material-ui/icons/ArrowDropDown';
import EditProfileDrawer from '../demand/components/EditProfile/index';
import SettingsDrawer from '../demand/components/SettingsDrawer/index';
import Error from 'Components/Error';
import { connect } from 'react-redux';
import { onUserLogout } from 'Actions/loginActions';
import { getCurentUser } from 'Actions/userActions';
import anime from 'animejs';
import EditCompanyInfo from '../demand/components/EditCompanyInfo';

// const HeaderAuth = props => {
//   const {
//     authenticated,
//     type,
//     user,
//     onUserLogout,
//     getCurentUser,
//     colored,
//   } = props;
//   const header = createRef();

//   const [anchorEl, setAnchorEl] = useState(null);
//   const [error, setError] = useState(null);
//   const [localUser, setLocalUser] = useState({});
//   // const [drawerType, setDrawerType] = useState({
//   //   editProfile: false,
//   //   editCompanyInfo: false,
//   //   settings: false,
//   // });

//   const [editProfile, setEditProfile] = useState(false);
//   const [editCompanyInfo, setEditCompanyInfo] = useState(false);
//   const [settings, setSettings] = useState(false);

//   useEffect(() => {
//     anime({
//       targets: header.current,
//       translateY: [-200, 0],
//       duration: 400,
//       delay: 600,
//       elasticity: 3,
//       easing: 'linear',
//     });
//     if (authenticated) {
//       getCurentUser()
//         .then(response => {
//           if (response.status === 200) setLocalUser(response.data);
//         })
//         .catch(error => console.error(error));
//     }
//   }, [authenticated]);

//   const handleClick = event => {
//     setAnchorEl(event.currentTarget);
//   };

//   const handleClose = () => {
//     setAnchorEl(null);
//   };

//   const openDrawer = prop => () => {
//     handleClose();
//     if (prop === 'editProfile') setEditProfile(true);
//     if (prop === 'editCompanyInfo') setEditCompanyInfo(true);
//     else setSettings(true);
//     // setDrawerType(prevState => ({
//     //   ...prevState,
//     //   [prop]: true,
//     // }));
//   };

//   const toggleDrawer = (side, open) => () => {
//     if (side === 'editProfile') setEditProfile(open);
//     if (side === 'editCompanyInfo') setEditCompanyInfo(open);
//     else setSettings(open);
//     // setDrawerType(prevState => ({
//     //   ...prevState,
//     //   [side]: open,
//     // }));
//     // this.setState({
//     //   [side]: open,
//     // });
//   };

//   const onCloseDrawer = () => {
//     // setDrawerType(prevState => ({
//     //   ...prevState,
//     //   editProfile: true,
//     //   editCompanyInfo: false,
//     // }));
//     setEditProfile(false);
//     setEditCompanyInfo(false);
//     setSettings(false);
//   };

//   const onErrorCancel = () => {
//     setError(null);
//   };

//   return (
//     <div
//       ref={header}
//       className={colored ? 'mini-header mini-header-colored' : 'mini-header'}
//     >
//       <Error errors={error} onCancel={onErrorCancel} />
//       <div className="mini-header__logo">
//         <Link className="" to="/">
//           <img src={logo} alt="" className="element-block" />
//         </Link>
//       </div>
//       {type === '/login' && !authenticated && (
//         <div className="mini-header__entry-switch">
//           <span className="t-secondary-16 t-color-w">
//             Don’t have an account?
//           </span>
//           <Link className="mui-button" to="/registration">
//             Register
//           </Link>
//           {window.location.pathname !== '/login' && (
//             <Link className="mui-button" to="/login">
//               Login
//             </Link>
//           )}
//         </div>
//       )}
//       {type === '/registration' && !authenticated && (
//         <div className="mini-header__entry-switch">
//           <span className="t-secondary-16 t-color-w">
//             Already have an account?
//           </span>
//           <Link className="mui-button" to="/login">
//             Login
//           </Link>
//         </div>
//       )}

//       {authenticated && (
//         <div className="mini-header__entry-switch">
//           <div className="loggedUser">
//             <AvatarUser
//               user={localUser}
//               onClick={handleClick}
//               imageId={localUser.imageId}
//             />
//             <IconButton
//               aria-label="More"
//               aria-owns={anchorEl ? 'long-menu' : null}
//               aria-haspopup="true"
//               onClick={handleClick}
//               className="custom-icon-button"
//             >
//               <MoreHoriz className="project-card-hover-more-icon" />
//             </IconButton>
//             <EditProfileDrawer
//               getCurentUser={getCurentUser}
//               editProfile={editProfile}
//               onClose={onCloseDrawer}
//             />
//             {user.length > 0 && (
//               <div>
//                 <EditProfileDrawer
//                   getCurentUser={getCurentUser}
//                   editCompanyInfo={editCompanyInfo}
//                   onClose={onCloseDrawer}
//                   user={localUser}
//                 />
//                 {console.log(props)}
//               </div>
//             )}
//             <SettingsDrawer
//               settings={settings}
//               close={toggleDrawer('settings', false)}
//               open={toggleDrawer('settings', true)}
//             />
//             <Menu
//               id="long-menu"
//               anchorEl={anchorEl}
//               open={Boolean(anchorEl)}
//               onClose={handleClose}
//             >
//               <MenuItem onClick={openDrawer('editProfile')}>
//                 Edit profile
//               </MenuItem>
//               <MenuItem onClick={openDrawer('editCompanyInfo')}>
//                 Edit company info
//               </MenuItem>
//               <MenuItem onClick={openDrawer('settings')}>Settings</MenuItem>
//               <MenuItem onClick={onUserLogout}>Logout</MenuItem>
//             </Menu>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

class HeaderAuth extends React.Component {
  header = createRef();

  state = {
    anchorEl: null,
    editProfile: false,
    editCompanyInfo: false,
    settings: false,
    error: null,
  };

  componentDidMount() {
    anime({
      targets: this.header.current,
      translateY: [-200, 0],
      duration: 400,
      delay: 600,
      elasticity: 3,
      easing: 'linear',
    });
    if (this.props.authenticated) {
      this.props.getCurentUser();
    }
  }

  // componentDidUpdate(prevProps) {
  //   if (!prevProps.authenticated && this.props.authenticated) {
  //     this.props.getCurentUser();
  //   }
  // }

  componentDidCatch(error, info) {
    this.setState({
      error,
    });
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };
  openDrawer = prop => () => {
    this.handleClose();
    this.setState({ [prop]: true });
  };
  toggleDrawer = (side, open) => () => {
    this.setState({
      [side]: open,
    });
  };

  onCloseDrawer = () => {
    this.setState({
      editProfile: false,
      editCompanyInfo: false,
    });
  };

  onErrorCancel = () => {
    this.setState({
      error: null,
    });
  };

  // UNSAFE_componentWillReceiveProps(props) {
  //   if (props !== this.props) {
  //     this.props.getCurentUser();
  //   }
  // }

  render() {
    return (
      <div
        ref={this.header}
        className={
          this.props.colored ? 'mini-header mini-header-colored' : 'mini-header'
        }
      >
        <Error errors={this.state.error} onCancel={this.onErrorCancel} />
        <div className="mini-header__logo">
          <Link className="" to="/">
            <img src={logo} alt="" className="element-block" />
          </Link>
        </div>
        {this.props.type === '/login' && !this.props.authenticated && (
          <div className="mini-header__entry-switch">
            <span className="t-secondary-16 t-color-w">
              Don’t have an account?
            </span>
            <Link className="mui-button" to="/registration">
              Register
            </Link>
            {window.location.pathname !== '/login' && (
              <Link className="mui-button" to="/login">
                Login
              </Link>
            )}
          </div>
        )}
        {this.props.type === '/registration' && !this.props.authenticated && (
          <div className="mini-header__entry-switch">
            <span className="t-secondary-16 t-color-w">
              Already have an account?
            </span>
            <Link className="mui-button" to="/login">
              Login
            </Link>
          </div>
        )}

        {this.props.authenticated && (
          <div className="mini-header__entry-switch">
            <div className="loggedUser">
              <AvatarUser
                user={this.props.user}
                onClick={this.handleClick}
                imageId={this.props.user.imageId}
              />
              <IconButton
                aria-label="More"
                aria-owns={this.state.anchorEl ? 'long-menu' : null}
                aria-haspopup="true"
                onClick={this.handleClick}
                className="custom-icon-button"
              >
                <MoreHoriz className="project-card-hover-more-icon" />
              </IconButton>
              <EditProfileDrawer
                getCurentUser={this.props.getCurentUser}
                editProfile={this.state.editProfile}
                onClose={this.onCloseDrawer}
              />
              {/* {this.props.user.hasArupDomain && ( */}
              <EditCompanyInfo
                getCurentUser={this.props.getCurentUser}
                editCompanyInfo={this.state.editCompanyInfo}
                onClose={this.onCloseDrawer}
              />
              {/* )} */}
              <SettingsDrawer
                settings={this.state.settings}
                close={this.toggleDrawer('settings', false)}
                open={this.toggleDrawer('settings', true)}
              />
              <Menu
                id="long-menu"
                anchorEl={this.state.anchorEl}
                open={Boolean(this.state.anchorEl)}
                onClose={this.handleClose}
              >
                <MenuItem onClick={this.openDrawer('editProfile')}>
                  Edit profile
                </MenuItem>
                {!this.props.user.hasArupDomain && (
                  <MenuItem onClick={this.openDrawer('editCompanyInfo')}>
                    Edit company info
                  </MenuItem>
                )}
                <MenuItem onClick={this.openDrawer('settings')}>
                  Settings
                </MenuItem>
                <MenuItem onClick={this.props.onUserLogout}>Logout</MenuItem>
              </Menu>
            </div>
          </div>
        )}
      </div>
    );
  }
}
const mapStateToProps = store => {
  return {
    authenticated: store.login.authenticated,
    user: store.user ? store.user.user : false,
  };
};

export default connect(mapStateToProps, { onUserLogout, getCurentUser })(
  HeaderAuth
);
